export default "__VITE_ASSET__BhCNMzrC__"